'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    AdminScaffoldingGeneric = require('components/Commons/AdminScaffolding/AdminScaffoldingGeneric'),
    Loading = require('components/Commons/Loading/Loading'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    GridItem = require('components/Commons/GridItem/GridItem'),
    Authentication = require('services/Security').Authentication,
    InventoryStore = require('stores/InventoryStore'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupImageChooser = require('components/Commons/BasicForm/FormGroupImageChooser/FormGroupImageChooser'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    ga = require('react-ga'),
    _ = require('lodash');

let IconsAdmin = React.createClass({displayName: "IconsAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder],

    getInitialState() {
        return {
            selectedIcon: null,
            isEditMode: false
        };
    },

    componentDidMount() {
        this.fetchIcons();
        ga.pageview('/icons-admin');
    },

    fetchIcons() {
        var self = this;
        InventoryStore.fetchIcons(function (icons) {
            self.setState({
                icons
            });
        });
    },

    _onDeleteIcon(icon, onSuccess, onFailure) {
        InventoryStore.deleteIcon(icon, onSuccess, onFailure);
    },

    _onChangeIcon(icon, onSuccess, onFailure) {
        InventoryStore.addIcon(icon, onSuccess, onFailure);
    },

    _onAddIcon(icon, onSuccess, onFailure) {
        InventoryStore.addIcon(icon, onSuccess, onFailure);
    },

    _onRowSelection(icon) {
        this.setState(prevState => {
            if (icon === prevState.selectedIcon) {
                return {
                    selectedIcon: null,
                    isEditMode: false
                };
            } else {
                return {
                    selectedIcon: icon,
                    isEditMode: true
                };
            }
        });
    },

    _onCancel() {
        this.setState({
            selectedIcon: null,
            isEditMode: false
        });
    },

    render() {
        if (!this.state.icons) {
            return (React.createElement(Loading, null));
        } else {
            const messages = {
                changeSuccessMessage: t('icons_admin_change_success'),
                changeFailureMessage: t('icons_admin_failure_success'),
                deleteSuccessMessage: t('icons_admin_delete_success'),
                addSuccessMessage: t('icons_admin_add_success'),
                addFailureMessage: t('icons_admin_add_failure')
            };
            const contextHolder = this.getContextHolderInstance();
            const {selectedIcon, icons, isEditMode} = this.state;

            const GridItemsEl = _.map(
                icons, item => {
                    return (
                        React.createElement(GridItem, {
                            icon: item, 
                            isChecked: 
                                _.get(item, 'cameFromApplicant', false) ||
                                _.get(this.state, 'selectedIcon.id') === _.get(item, 'id'), 
                            
                            onCheck:  this._onRowSelection}
                        )
                    );
                }
            );
            const formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    displayAttribute: "name", 
                    readerAttribute: "iconDetail.displayName", 
                    writerAttribute: "displayName", 
                    name: t('icons_admin_name_label'), 
                    value: selectedIcon, 
                    label: t('icons_admin_name_label')}
                ),

                React.createElement(FormGroupDropdown, {
                    operationsHolder: contextHolder, 
                    items: icons, 
                    displayAttribute: "text", 
                    readerAttribute: "iconDetail.name", 
                    writerAttribute: "urlImage", 
                    name: t('icon'), 
                    value: selectedIcon, 
                    isRequired: false, 
                    isEditMode: isEditMode}
                ),

                React.createElement(FormGroupImageChooser, {
                    operationsHolder: contextHolder, 
                    displayAttribute: "imageSrc", 
                    readerAttribute: "iconDetail.displayName", 
                    writerAttribute: "urlCustomImage", 
                    name: "imageSrc", 
                    value: selectedIcon, 
                    label: t('icons_admin_select_icon')}
                )
            ];

            return (
                React.createElement("div", {className: "brewhouse-view"}, 
                    React.createElement(AdminScaffoldingGeneric, {
                        title: t('icons_admin_title'), 
                        messages: messages, 
                        contextHolder: contextHolder, 
                        value: selectedIcon, 
                        fetchItems:  this.fetchIcons, 
                        headerFields: formFieldsEl, 
                        onAdd:  this._onAddIcon, 
                        onChange:  this._onChangeIcon, 
                        onCancel:  this._onCancel, 
                        onDelete:  this._onDeleteIcon
                    }, 
                        GridItemsEl 
                    )
                )
            );
        }
    }
});

module.exports = IconsAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/IconsAdmin/IconsAdmin.jsx
 **/